export const magicbytes=new Uint8Array([102,103,98,3,102,103,98,0]);export const SIZE_PREFIX_LEN=4;
//# sourceMappingURL=constants.js.map